module.exports = __webpack_public_path__ + "img/icoUserReg.df2b1668.png";